export { default as RichText } from './RichText'

export const isEmptyText = (item) => (item.text === '')
